<template>
  <div
    :class="`ims-avatar size-${size}`"
    :style="`background-image:url(${src})`"
  >
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true
    };
  },
  props: {
    src: {
      type: String,
      default() {
        return ``;
      }
    },
    size: {
      type: String,
      default() {
        return 'md';
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';

$xs: 22px;
$sm: 40px;
$md: 60px;
$lg: 100px;
$xl: 110px;

.ims-avatar {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all 0.2s ease-in-out;
  border: solid 2px $primary;
  box-shadow: 0px 2px 10px -2px rgba(0, 0, 0, 0.34);
  position: relative;
  background-color: #fff;
  color: $blue;
  display: flex;
  align-items: center;
  justify-content: center;

  .ims-badge {
    min-width: 30px;
  }

  &:after {
    // border: solid 2px rgba(255, 255, 255, 0.5);
    width: calc(100% - 1px);
    height: calc(100% - 1px);
    border-radius: 50%;
    display: block;
    position: absolute;
    content: '';
  }

  .top-left {
    position: absolute;
    top: 0px;
    left: -10px;
  }

  .top-right {
    position: absolute;
    top: -2px;
    right: -12px;
  }

  &.size-xs {
    height: $xs !important;
    width: $xs !important;
    border-radius: $xs * 0.5;
  }
  &.size-sm {
    height: $sm !important;
    width: $sm !important;
    border-radius: $sm * 0.5;
  }
  &.size-md {
    height: $md !important;
    width: $md !important;
    border-radius: $md * 0.5;
    .top-right {
      top: -12px;
      right: -20px;
    }
  }
  &.size-lg {
    height: $lg !important;
    width: $lg !important;
    border-radius: $lg * 0.5;
  }
  &.size-xl {
    height: $xl !important;
    width: $xl !important;
    border-radius: $xl * 0.5;
  }
}
</style>
